import type { JsonApiResponse } from 'json-api-normalizer';

import api from 'api/apiInstance';
import { convertJsonToFormData, mapFormData } from 'helpers/formData';

export interface PracticeBrochureReorderPatchOptions {
  position: number;
}

export function practiceBrochureReorderApi(path: string) {
  return {
    path,
    PATCH: (params: PracticeBrochureReorderPatchOptions) =>
      api.patch<JsonApiResponse>(
        path,
        convertJsonToFormData({
          data: {
            attributes: mapFormData(params),
          },
        })
      ),
  };
}
